import { SparkSuspense } from '@sparklayer-io/spark-dash-core/components/spark-suspense';
import { useEnv } from '@sparklayer-io/spark-dash-core/context/env-context';
import { withPageProviders } from '@sparklayer-io/spark-dash-pages/context/page-context';
import { Alert, Card, EmptyState, Page } from '@ui/themed';
import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';
import { MetafieldGroupCard } from '../components/metafield-group-card';
import { PLATFORM_DOCS_URLS, PLATFORM_PATH, supportsMetafields } from '../constants';
import { useMetafieldConfiguration } from '../hooks/use-metafield-configuration';

const PAGE = 'features:platform.pages.metafields_page' satisfies I18nPrefix;

export const MetafieldsPage = withPageProviders(MetafieldsPageContent);

function MetafieldsPageContent() {
  const env = useEnv();
  const { data, isLoading, isError, isFetching, refetch } = useMetafieldConfiguration();

  return (
    <Page
      title={t(`${PAGE}.header.title`)}
      description={t(`${PAGE}.header.description`)}
      learnMoreUrl={PLATFORM_DOCS_URLS.metafieldsPage}
      backUrl={PLATFORM_PATH}
    >
      {!supportsMetafields(env.connected_platform) ? (
        <Card>
          <EmptyState
            title={t(`${PAGE}.unsupported.title`)}
            subtitle={t(`${PAGE}.unsupported.subtitle`)}
          />
        </Card>
      ) : (
        <>
          <Alert variant="info" headingLevel="h2">
            {t(`${PAGE}.note`)}
          </Alert>
          <SparkSuspense
            isLoading={isLoading}
            isError={isError}
            onReload={() => void refetch()}
            errorMessage={t('errors:generic')}
          >
            {(data ?? []).map((group) => (
              <MetafieldGroupCard key={group.name} group={group} isFetching={isFetching} />
            ))}
          </SparkSuspense>
        </>
      )}
    </Page>
  );
}
